"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayProperties = exports.DataType = exports.DealSummaryOfferTypeEnum = exports.OfferPaths = void 0;
// These are used to extract values from the offer payload generated by DS/SDP clients
var OfferPaths;
(function (OfferPaths) {
    OfferPaths["TERM"] = "payment.months";
    OfferPaths["TRADE_VALUE"] = "tradeIn.value";
    OfferPaths["TRADE_APPLIED_FINANCE"] = "tradeIn.isAmountAppliedToFinancing";
    OfferPaths["TRADE_OWED"] = "tradeIn.amountOwed";
    OfferPaths["TRADE_ADJ"] = "tradeIn.adjustedTradeInValue";
    OfferPaths["LISTED_PRICE"] = "vehicle.listedPrice";
    OfferPaths["RETAIL_PRICE"] = "vehicle.retailPrice";
    OfferPaths["ANNUAL_MILES"] = "leaseTerms.mileage";
    OfferPaths["DEALER_FEES"] = "payment.dealerFees";
    OfferPaths["AMT_FINANCED"] = "payment.amountFinanced";
    OfferPaths["APR"] = "payment.apr";
    OfferPaths["INCENTIVES"] = "payment.appliedIncentiveAmount";
    OfferPaths["DMV_FEES"] = "payment.fees.total";
    OfferPaths["TAXES"] = "payment.totalTax";
    OfferPaths["MOMTHLY_PMT"] = "payment.monthlyPayment";
    OfferPaths["OFFER_PRICE"] = "offerPrice";
    OfferPaths["TAXES_CAPPED"] = "payment.capitalizedTaxTotal";
    OfferPaths["TAXES_UP_FRONT"] = "payment.upfrontTaxTotal";
    OfferPaths["TOTAL_TAX"] = "payment.totalTax";
    OfferPaths["SECURITY_DEPOSIT"] = "payment.securityDeposit";
})(OfferPaths = exports.OfferPaths || (exports.OfferPaths = {}));
// Cash is not included here because Cash Deals do not depend on the dealSummary object
var DealSummaryOfferTypeEnum;
(function (DealSummaryOfferTypeEnum) {
    DealSummaryOfferTypeEnum["FINANCE"] = "finance";
    DealSummaryOfferTypeEnum["LEASE"] = "lease";
    DealSummaryOfferTypeEnum["CASH"] = "cash";
})(DealSummaryOfferTypeEnum = exports.DealSummaryOfferTypeEnum || (exports.DealSummaryOfferTypeEnum = {}));
var DataType;
(function (DataType) {
    DataType["APR"] = "apr";
    DataType["DATE"] = "date";
    DataType["MONEY"] = "money";
    DataType["MILES"] = "miles";
    DataType["MONTHS"] = "months";
    DataType["PERCENTAGE"] = "percentage";
    DataType["SEPARATOR"] = "separator";
    DataType["STRING"] = "string";
})(DataType = exports.DataType || (exports.DataType = {}));
var DisplayProperties;
(function (DisplayProperties) {
    DisplayProperties["HIDE"] = "hide";
    DisplayProperties["IMPORTANT"] = "important";
    DisplayProperties["UNNATURAL"] = "negative";
    DisplayProperties["ADJUSTED_CASH_DOWN"] = "adjustedCashDown";
    DisplayProperties["SEPARATOR"] = "separator";
})(DisplayProperties = exports.DisplayProperties || (exports.DisplayProperties = {}));
